import _find from 'lodash/find';

import { Blocks } from '@/components/PageEditor/types';

import {
  ContentType,
  onSetCommentThreadIdPayloadType,
  onSetImportLessonAttrsPayloadType,
  onSetLessonAssigneePayloadType,
  onUpdateContentTextType,
  onUpdateLessonStatusPayloadType,
} from '../types';

export function findContentByType(content?: ContentType[], type?: Blocks) {
  return _find(content, { type });
}

export const getBlockByType = (content?: ContentType[], type?: Blocks) =>
  findContentByType(content, type)?.content?.[0];

export const onSetLessonAssignee = (
  payload: onSetLessonAssigneePayloadType,
  lessonContent?: ContentType[],
) => {
  const assigneeAttributes = findContentByType(lessonContent, Blocks.LESSON_ASSIGNEE)?.attrs;
  if (assigneeAttributes) {
    assigneeAttributes.userId = payload.id;
  }
};

export const onUpdateLessonStatus = (
  payload: onUpdateLessonStatusPayloadType,
  lessonContent?: ContentType[],
) => {
  const statusAttributes = findContentByType(lessonContent, Blocks.LESSON_STATUS)?.attrs;
  if (statusAttributes) {
    statusAttributes.status = payload.newStatus;
  }
};

export const onSetCommentThreadId = (
  payload: onSetCommentThreadIdPayloadType,
  lessonContent?: ContentType[],
) => {
  const commentAttributes = findContentByType(lessonContent, Blocks.LESSON_COMMENTS)?.attrs;
  if (commentAttributes) {
    commentAttributes.commentThreadId = payload.postId;
  }
};

export const onUpdateContentText = (
  payload: onUpdateContentTextType,
  lessonContent?: ContentType[],
) => {
  const { value, type } = payload;
  const textBlock = getBlockByType(lessonContent, type);
  if (textBlock) {
    textBlock.text = value;
  }
};

export const onSetImportLessonAttrs = (
  payload: onSetImportLessonAttrsPayloadType,
  lessonContent?: ContentType[],
) => {
  const refBlock = findContentByType(lessonContent, Blocks.REF);
  if (refBlock?.attrs) {
    refBlock.attrs = { ...refBlock.attrs, ...payload };
  }
};
